// dynamic-min-age-by-vehicle.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

function calculateAge(date: Date): number {
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const m = today.getMonth() - date.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < date.getDate())) age--;
  return age;
}

export function minAge18Validator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const birthdayCtrl = control;

    if (!birthdayCtrl) return null;

    const rawDate = birthdayCtrl.value;
    if (!rawDate) {
      // Si no hi ha data, deixa que el required actuï si existeix
      clearErrorKey(birthdayCtrl, 'edatMinima18');
      return null;
    }

    const birthDate = new Date(rawDate);
    const age = isNaN(birthDate.getTime()) ? NaN : calculateAge(birthDate);

    if (isNaN(age) || age < 18) {
      setErrorKey(birthdayCtrl, 'edatMinima18', {
        requiredAge: 18,
        actualAge: isNaN(age) ? null : age,
      });
    } else {
      clearErrorKey(birthdayCtrl, 'edatMinima18');
    }

    // L'error es col·loca al control `birthday`
    return null;
  };
}

/**
 * Valida que birthday compleix l'edat mínima segons vehicleType.
 * @param vehicleCtrlName  Nom del control, ex: 'vehicleType'
 * @param birthdayCtrlName Nom del control, ex: 'birthday'
 * @param mapOrFn          Diccionari o funció que retorna edat mínima
 */
export function minAgeValidator(
  vehicleCtrlName: string,
  birthdayCtrlName: string,
  mapOrFn: Record<any, number> | ((vehicleType: any) => number)
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;
    const vehicleType = group.get(vehicleCtrlName)?.value;
    const birthdayCtrl = group.get(birthdayCtrlName);

    if (!birthdayCtrl) return null;

    const rawDate = birthdayCtrl.value;
    if (!rawDate) {
      // Sense data: deixa que el required del propi control s'encarregui
      clearErrorKey(birthdayCtrl, 'edatMinima');
      return null;
    }

    const minAge =
      typeof mapOrFn === 'function' ? mapOrFn(vehicleType) : mapOrFn?.[vehicleType] ?? 18; // per defecte 18 si no es troba

    const birthDate = new Date(rawDate);
    const age = isNaN(birthDate.getTime()) ? NaN : calculateAge(birthDate);

    if (isNaN(age) || age < minAge) {
      setErrorKey(birthdayCtrl, 'edatMinima', {
        requiredAge: minAge,
        actualAge: isNaN(age) ? null : age,
      });
    } else {
      clearErrorKey(birthdayCtrl, 'edatMinima');
    }

    // Retornem null a nivell de grup; l'error viu al control 'birthday'
    return null;
  };
}

function setErrorKey(ctrl: AbstractControl, key: string, value: any) {
  const errors = { ...(ctrl.errors ?? {}) };
  errors[key] = value;
  ctrl.setErrors(errors);
}

function clearErrorKey(ctrl: AbstractControl, key: string) {
  const errors = { ...(ctrl.errors ?? {}) };
  if (key in errors) {
    delete errors[key];
    ctrl.setErrors(Object.keys(errors).length ? errors : null);
  }
}
